import PropTypes from 'prop-types'

const MessagesIcon = ({ title }: any) => (
  <svg width={31} height={30} viewBox="0 0 31 30">
    <title>{title}</title>
    <g strokeWidth={3}>
      <path d="M2.3 7.636v-3a2.4 2.4 0 012.4-2.4h21.6a2.4 2.4 0 012.4 2.4v13.2a2.4 2.4 0 01-2.4 2.4h-9.6l-8.4 6v-6H4.7a2.4 2.4 0 01-2.4-2.4v-6.6h14.4" />
      <path strokeLinecap="square" d="M11.9 6.436l4.8 4.8-4.8 4.8" />
    </g>
  </svg>
)

MessagesIcon.displayName = 'MessagesIcon'

MessagesIcon.propTypes = {
  title: PropTypes.string
}

MessagesIcon.defaultProps = {
  title: 'Messages'
}

export default MessagesIcon
